// Mock data for Trust Me Laundry

export const BRAND = {
  name: 'Trust Me Laundry',
  tagline: 'No.1 Laundry Express Terpercaya',
  logo: 'https://customer-assets.emergentagent.com/job_867aa340-1d60-42a6-b0d4-bf77ab1ef38c/artifacts/sw9vbwoy_unnamed.jpg',
  phone: '0813-2108-255',
  phoneLink: '08132108255',
  whatsapp: 'https://wa.me/628132108255',
  address: 'Apartemen Kebagusan City, Kebagusan, Ps. Minggu, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12520',
  addressShort: 'Apartemen Kebagusan City, Jakarta Selatan',
  city: 'Jakarta Selatan',
  province: 'DKI Jakarta',
  hours: 'Setiap hari • 08:00 – 20:00 WIB',
  mapEmbed: 'https://www.google.com/maps?q=Apartemen+Kebagusan+City+Jakarta+Selatan&output=embed',
  mapLink: 'https://maps.google.com/?q=Apartemen+Kebagusan+City+Jakarta+Selatan',
  instagram: 'https://www.instagram.com/trustme_laundry',
  instagramHandle: '@trustme_laundry',
  tiktok: 'https://www.tiktok.com/@trustme_laundry',
  tiktokHandle: '@trustme_laundry',
  facebook: 'https://www.facebook.com/share/1CsMqXdj2q/?mibextid=wwXlfr',
  facebookHandle: 'Trust Me Laundry',
};

// Real outlet photos uploaded by owner
export const galleryPhotos = [
  'https://customer-assets.emergentagent.com/job_trust-laundry/artifacts/8epg1pf4_4166ce78-acd3-45ff-ab78-cec12be0fe38.jpeg',
  'https://customer-assets.emergentagent.com/job_trust-laundry/artifacts/z8e2uzik_ca0ba49e-6781-433f-846b-d07eb28adb8b.jpeg',
  'https://customer-assets.emergentagent.com/job_trust-laundry/artifacts/8jropsnc_476bd537-3227-4526-b8e0-bd0aeb7efad4.jpeg',
  'https://customer-assets.emergentagent.com/job_trust-laundry/artifacts/9i5bt66a_9f847864-d5c3-4874-b89f-3aaebc2e8a53.jpeg',
  'https://customer-assets.emergentagent.com/job_trust-laundry/artifacts/b1h38dyk_TML2.jpeg',
];

export const heroImage = 'https://customer-assets.emergentagent.com/job_trust-laundry/artifacts/9i5bt66a_9f847864-d5c3-4874-b89f-3aaebc2e8a53.jpeg';
export const aboutImage = 'https://customer-assets.emergentagent.com/job_trust-laundry/artifacts/8epg1pf4_4166ce78-acd3-45ff-ab78-cec12be0fe38.jpeg';

// Lottie animations - all laundry/cleaning themed (consistent style)
// Verified working URLs from lottiefiles.com CDN
export const services = [
  { name: 'Daily Kiloan',           lottie: 'https://assets3.lottiefiles.com/packages/lf20_GofK09iPAE.json', emoji: '🧺' },
  { name: 'Cuci & Setrika',         lottie: 'https://assets9.lottiefiles.com/packages/lf20_xlmz9xwm.json',   emoji: '👕' },
  { name: 'Laundry Bed Cover',      lottie: 'https://assets3.lottiefiles.com/packages/lf20_bdlrkrqv.json',   emoji: '🛏️' },
  { name: 'Laundry Tas',            lottie: 'https://assets1.lottiefiles.com/packages/lf20_qmfs6c3i.json',   emoji: '👜' },
  { name: 'Laundry Karpet',         lottie: 'https://assets6.lottiefiles.com/packages/lf20_5tkzkblw.json',   emoji: '🪑' },
  { name: 'Laundry Gorden',         lottie: 'https://assets2.lottiefiles.com/packages/lf20_iorpbol0.json',   emoji: '🪟' },
  { name: 'Laundry Sprei',          lottie: 'https://assets1.lottiefiles.com/packages/lf20_yzoqyyqf.json',   emoji: '🛌' },
  { name: 'Laundry Bantal & Selimut', lottie: 'https://assets2.lottiefiles.com/packages/lf20_kuhijlvx.json', emoji: '🧸' },
];

export const laundryTypes = [
  'Daily Kiloan',
  'Cuci & Setrika',
  'Laundry Bed Cover',
  'Laundry Tas',
  'Laundry Karpet',
  'Laundry Gorden',
  'Laundry Sprei',
  'Laundry Bantal & Selimut',
  'Lainnya',
];

export const whyUs = [
  {
    title: 'Terpercaya',
    body: 'Dipercaya oleh pelanggan, kami bangga menjadi pilihan utama dalam layanan laundry berkualitas. Reputasi dibangun atas dasar kepuasan pelanggan yang tinggi, hasil bersih dan wangi, serta layanan ramah dan profesional.',
  },
  {
    title: 'Tim Profesional',
    body: 'Layanan terbaik hanya dapat diberikan oleh tim yang berdedikasi. Tim kami terlatih dan berpengalaman menangani berbagai jenis pakaian dan kain, memastikan setiap cucian ditangani dengan hati-hati.',
  },
  {
    title: 'Express 3 Jam Selesai',
    body: 'Butuh layanan cepat? Kami hadir dengan layanan express yang menjamin cucian Anda selesai dalam 3 jam. Tanpa mengurangi kualitas hasil cucian, cocok untuk Anda yang memiliki mobilitas tinggi.',
  },
  {
    title: 'Antar Jemput 30 Menit',
    body: 'Kenyamanan Anda prioritas kami. Kami menyediakan layanan antar-jemput gratis dengan waktu penjemputan maksimal 30 menit setelah Anda melakukan pemesanan via WhatsApp atau telepon.',
  },
  {
    title: 'Pembayaran Mudah',
    body: 'Nikmati kemudahan pembayaran: tunai, transfer bank, QRIS, hingga dompet elektronik. Setiap transaksi aman dan nyaman bagi Anda.',
  },
  {
    title: 'Higienis & Berkualitas',
    body: '1 mesin 1 customer, cucian tidak akan tertukar dengan pelanggan lain. Menggunakan detergent premium yang aman untuk kulit sensitif dan lingkungan.',
  },
];

// Natural, casual testimonials - like real social media comments
export const testimonials = [
  {
    name: 'Rosa Aprilia',
    handle: '@rosa.april',
    avatar: 'https://images.unsplash.com/photo-1746513930405-005d20013dd6?w=160&q=80&auto=format&fit=crop&crop=faces',
    text: 'Fast respon banget ka, hasilnya juga wangi 😍 jadi langganan deh sekarang',
    rating: 5,
    date: '2 hari yang lalu',
  },
  {
    name: 'Radya Ananta',
    handle: '@radyaa_',
    avatar: 'https://images.unsplash.com/photo-1601879185869-def4bcc650a2?w=160&q=80&auto=format&fit=crop&crop=faces',
    text: 'Recommended banget buat anak kantoran yg sibuk, bisa antar jemput pula. Mantap',
    rating: 5,
    date: '5 hari yang lalu',
  },
  {
    name: 'Salsabila S.',
    handle: '@salsabila.sp',
    avatar: 'https://images.unsplash.com/photo-1607529379169-5804750c1f9a?w=160&q=80&auto=format&fit=crop&crop=faces',
    text: 'penyelamat anak kos! harga ramah dompet, hasilnya bersih wangi. thank you Trust Me 🙏',
    rating: 5,
    date: '1 minggu yang lalu',
  },
  {
    name: 'Lillian Putri',
    handle: '@lilputri',
    avatar: 'https://images.unsplash.com/photo-1562904403-a5106bef8319?w=160&q=80&auto=format&fit=crop&crop=faces',
    text: 'Udah 3 bulan langganan. So far ga pernah kecewa, tepat waktu terus.',
    rating: 5,
    date: '1 minggu yang lalu',
  },
  {
    name: 'Arief Fathur',
    handle: '@ariffathur',
    avatar: 'https://images.unsplash.com/photo-1544168190-79c17527004f?w=160&q=80&auto=format&fit=crop&crop=faces',
    text: 'Lagi traveling ke jaksel, baju kotor numpuk. Untung ada Trust Me, 3 jam jadi 👌',
    rating: 5,
    date: '2 minggu yang lalu',
  },
  {
    name: 'Merti Hasanah',
    handle: '@mertihsnh',
    avatar: 'https://images.unsplash.com/photo-1613447895590-97f008b7fff3?w=160&q=80&auto=format&fit=crop&crop=faces',
    text: 'Wanginyaa awet bgt, baju aku jadi kayak baru lagi. Makasih ya!',
    rating: 5,
    date: '2 minggu yang lalu',
  },
  {
    name: 'Bayu Pratama',
    handle: '@bayupratama',
    avatar: 'https://images.unsplash.com/photo-1701980889802-55ff39e2e973?w=160&q=80&auto=format&fit=crop&crop=faces',
    text: 'Pickup nya cepet, ga sampe 30 menit. Worth the price banget sih',
    rating: 5,
    date: '3 minggu yang lalu',
  },
  {
    name: 'Inggit Chairun',
    handle: '@inggitcr',
    avatar: 'https://images.unsplash.com/photo-1599296103214-6ae28aa6e083?w=160&q=80&auto=format&fit=crop&crop=faces',
    text: '1 mesin 1 customer policy nya bikin tenang. Ga akan ketuker sama baju org lain ✨',
    rating: 5,
    date: '3 minggu yang lalu',
  },
  {
    name: 'Dimas Aditya',
    handle: '@dimas.adit',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=160&q=80&auto=format&fit=crop&crop=faces',
    text: 'Dari semua laundry yg pernah aku coba di area Kebagusan, ini paling rapih lipatannya 🔥',
    rating: 5,
    date: '1 bulan yang lalu',
  },
  {
    name: 'Putri Maharani',
    handle: '@putrimhrn',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=160&q=80&auto=format&fit=crop&crop=faces',
    text: 'Bed cover & sprei aku dicuci di sini, bersih banget hasilnya. Bakal balik lagi!',
    rating: 5,
    date: '1 bulan yang lalu',
  },
];

export const partners = [
  {
    name: 'Sisimu Coffee & Cafe',
    logo: 'https://customer-assets.emergentagent.com/job_trust-laundry/artifacts/gejn5b1z_images.jpg',
  },
];

// E-wallet & QRIS payment methods
export const ewallets = [
  { name: 'OVO',   logo: 'https://upload.wikimedia.org/wikipedia/commons/e/eb/Logo_ovo_purple.svg' },
  { name: 'GoPay', logo: 'https://upload.wikimedia.org/wikipedia/commons/8/86/Gopay_logo.svg' },
  { name: 'DANA',  logo: 'https://upload.wikimedia.org/wikipedia/commons/7/72/Logo_dana_blue.svg' },
  { name: 'Tunai', icon: 'banknote' },
];

export const qrisPayment = [
  { name: 'QRIS', logo: 'https://upload.wikimedia.org/wikipedia/commons/e/e1/QRIS_logo.svg' },
];

export const outlets = [
  {
    name: 'Trust Me Laundry Kebagusan',
    city: 'Jakarta Selatan',
    img: 'https://customer-assets.emergentagent.com/job_trust-laundry/artifacts/z8e2uzik_ca0ba49e-6781-433f-846b-d07eb28adb8b.jpeg',
    address: 'Apartemen Kebagusan City, Kebagusan, Ps. Minggu, Jakarta Selatan 12520',
    hours: 'Setiap hari • 08:00 – 20:00',
  },
];

export const outletCities = ['Semua', 'Jakarta Selatan'];
